import { collection, getDoc, setDoc } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { getDocs, doc } from 'firebase/firestore'
import { auth, db } from "../../firebase";
import "./studentLogin.css";
import { Link } from "react-router-dom";
export default function Display(prop) {
  const [joblist, setJoblist] = useState([]);
  const [resume, setresume] = useState("");
  const [name, setname] = useState("");
  const [poster, setposter] = useState("");
  const [position, setposition] = useState("");
  const ref = collection(db, `Industry/${prop.uid}/more-details`);
  const [user,setUser] = useState();
  useEffect(()=>{
    getDoc(doc(db, "users", auth.currentUser.uid)).then((docSnap) => {
        if (docSnap.exists) {
          setUser(docSnap.data());
        }
      });
  },[])
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  }, []);

  const apply = (postid, resume,name,position,salary) => {
      setDoc(doc(db, `Industry/${prop.uid}/Candidate/${postid}/applied`, auth.currentUser.email), {
        candi: auth.currentUser.uid,
        cid: prop.uid,
        postid: postid,
        resume: resume,
        position:position,
        name:name,
        email:auth.currentUser.email,
        contact:user.contact,
        classes:user.classes,
        department:user.department
      })
      setDoc(doc(db, `appliedin/${auth.currentUser.uid}/applieds`, postid), {
        candidate: auth.currentUser.uid,
        compid: prop.uid,
        postide: postid,
        position:position,
        cname:prop.name,
        salary:salary,
        status:"Not updated yet"
      })
      
      setposter(poster)
      alert("SuccessFully Applied")

  }
  const [popupActive, setPopupActive] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()

    if (
      !name ||
      !resume
      
    ) {
      alert("Please fill out all fields")
      return
    }




    setresume("");
    setname("");
    setPopupActive(false)
  }

  return (
    <>
     <div className='maindisplay'>
      <div className="recipes">
      {
        joblist.map((post,i) => {
          return (
            <>
             <div className="recipe" key={i}>
             <h2 className="position"> Company name : {prop.name} </h2> 
            <div className="position">Position : {post.position} </div>
            <hr/>
              <div className="preedit"><span className="postedit">Requirements : </span> {post.requirment} </div>
              <div className="preedit"><span className="postedit">Salary : </span>{post.salary} </div>
              <div className="preedit"><span className="postedit">Vacancy :  </span>{post.vacancy} </div>
              <div className="preedit"><span className="postedit">Last Date to apply :  </span>{post.lastdate} </div>
             
              {/* <input type={'url'} onChange={(e) => setresume(e.target.value)} />
              <button onClick={() => apply(post.postid, resume)}>apply here</button> */}
              <div className='buttons'>
              <Link className="btn-success btn" to="/viewindustry" state={{ compid:post.cid }}>Company Details</Link>
              <button className="btn btn-warning" onClick={() => (setPopupActive(!popupActive),setposter(post.postid),setposition(post.position))}>Apply Job</button>
              </div>

              </div>
              { popupActive && <div className="popup">
        <div className="popup-inner">
          <h2>Apply for Job</h2>

          <form onSubmit={handleSubmit}>

            <div className="form-group">
              <label>Name</label>
               <input type="text" value={name} onChange={(e) => setname(e.target.value)} />
            </div>

            <div className="form-group">
              <label>Resume Link</label>
              <input type={'url'} value={resume} onChange={(e) => setresume(e.target.value)} />
            </div>

            <div className="buttons">
            <button className="btn btn-warning" onClick={() => apply(poster, resume,name,position,post.salary)} >Apply Job</button>
              <button type="button" class="remove" onClick={() => setPopupActive(false)}>Close</button>
            </div>

          </form>
        </div>
      </div>}
            </>
          )

        })
      }
      </div>
      </div>
    </>
  )
}



// let temp;
//     await getDoc(doc(db, "selected", ide)).then((docSnap) => {
//       if (docSnap.exists) {
//         // setUser(docSnap.data());
//         temp = docSnap.data();
//         // ans=true;
//       }
//     });
//     // console.log(temp.position)

//     if (!temp) {
//       await setDoc(doc(db, "selected", ide), {
//         // position: [...user.position,{ cid:cid,stuid:ide,postid:postid }],
//         position: [{ cid: cid, stuid: ide, postid: postid }],
//       });
//     } else {
//       // let arr = [...temp.position,{ cid:cid,stuid:ide,postid:postid }];
//       // let set = new Set(arr);
//       // console.log(set);
//       await setDoc(doc(db, "selected", ide), {
//         position: [...temp.position, { cid: cid, stuid: ide, postid: postid }],
//         // position: [{ cid:cid,stuid:ide,postid:postid }],
//       });